/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-07-02T19:10:02.079
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import BasicLayout from '@/layouts/basic-layout';

const meta = {
auth: true
};

const pre = 'rentmanage-rentrepairworkorderassign-'

export default 
{
path: '/rentmanage/rentrepairworkorderassign',
name: 'rentmanage-rentrepairworkorderassign',
redirect: {
name: '${pre}-index'
}
,

meta:{
...meta,
},

component: BasicLayout ,
children:
[
{
path: 'index',
name: '${pre}rentrepairworkorderassign-index',

meta:{
...meta,
title: '工单指派'
},

component: () => import('@/pages/rentmanage/rentrepairworkorderassign/index') ,
},
{
path: 'detail-edit/:id',
name: '${pre}rentrepairworkorderassign-detail-edit',
auth: [
'hidden'
],

meta:{
...meta,
title: '工单指派编辑'
},

component: () => import('@/pages/rentmanage/rentrepairworkorderassign/detail-edit') ,
},
{
path: 'detail-edit',
name: '${pre}rentrepairworkorderassigndetail-create',
auth: [
'hidden'
],

meta:{
...meta,
title: '工单指派新增'
},

component: () => import('@/pages/rentmanage/rentrepairworkorderassign/detail-edit') ,
},
{
path: 'detail-view/:id',
name: '${pre}rentrepairworkorderassignView',
auth: [
'hidden'
],

meta:{
...meta,
title: '工单指派详情查看'
},

component: () => import('@/pages/rentmanage/rentrepairworkorderassign/detail-view') ,
},
]
};
